import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateComponent = _resolveComponent("DateComponent")!
  const _component_RangeFieldLayout = _resolveComponent("RangeFieldLayout")!

  return (_openBlock(), _createBlock(_component_RangeFieldLayout, { labels: _ctx.labels }, {
    from: _withCtx(() => [
      _createVNode(_component_DateComponent, {
        modelValue: _ctx.fromModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromModel) = $event)),
        placeholder: _ctx.hasLabels ? undefined : _ctx.placeholders[0],
        modClass: "redesigned popover-left",
        mode: _ctx.mode,
        dateIcon: "",
        typeable: _ctx.typeable,
        upperLimit: _ctx.rangeLimits.from.upper,
        lowerLimit: _ctx.rangeLimits.from.lower,
        required: _ctx.required,
        disabled: _ctx.disabled,
        hasInputMask: _ctx.hasInputMask,
        clearable: _ctx.clearable,
        isDirtyValidation: ""
      }, null, 8, ["modelValue", "placeholder", "mode", "typeable", "upperLimit", "lowerLimit", "required", "disabled", "hasInputMask", "clearable"])
    ]),
    to: _withCtx(() => [
      _createVNode(_component_DateComponent, {
        modelValue: _ctx.toModel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toModel) = $event)),
        placeholder: _ctx.hasLabels ? undefined : _ctx.placeholders[1],
        modClass: "redesigned",
        mode: _ctx.mode,
        dateIcon: "",
        typeable: _ctx.typeable,
        upperLimit: _ctx.rangeLimits.to.upper,
        lowerLimit: _ctx.rangeLimits.to.lower,
        required: _ctx.required,
        disabled: _ctx.disabled,
        hasInputMask: _ctx.hasInputMask,
        clearable: _ctx.clearable,
        isDirtyValidation: ""
      }, null, 8, ["modelValue", "placeholder", "mode", "typeable", "upperLimit", "lowerLimit", "required", "disabled", "hasInputMask", "clearable"])
    ]),
    _: 1
  }, 8, ["labels"]))
}